import { Navigate, Route, Routes } from "react-router-dom";
import { LayoutNew } from "./components/LayoutNew/LayoutNew";
import { ProjectsTab } from "./components/ProjectsTab/ProjectsTab";
import { DashboardTab } from "./components/DashboardTab/DashboardTab";
import { Project } from "./components/Project/Project";
import { SectionDoc } from "./components/SectionDoc/SectionDoc";
import { Relevance } from "./components/Relevance/Relevance";

export const App = () => {
  return (
    <Routes>
      <Route path="main" element={<LayoutNew />}>
        <Route path="dashboard" element={<DashboardTab />} />
        <Route path="projects" element={<ProjectsTab />} />
        <Route path="projects/:id" element={<Project />}/>
        <Route path="projects/:id/:seriesId" element={<SectionDoc />}/>
        <Route path="projects/relevance" element={<Relevance />}/>
      </Route>
      <Route path="*" element={<Navigate to="/main/projects" replace />} />
    </Routes>
  );
};
